module.exports = __webpack_public_path__ + "static/media/13.c1d6209e.png";